'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _urls = require('../../../utils/urls');

var _dropDownMenu = require('@liveauctioneers/caterwaul-components/lib/dropDownMenu');

var _dropDownMenu2 = _interopRequireDefault(_dropDownMenu);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _FormattedMessage = require('../../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _link = require('@liveauctioneers/caterwaul-components/lib/link');

var _link2 = _interopRequireDefault(_link);

var _FindAuctions = require('./FindAuctions.scss');

var _FindAuctions2 = _interopRequireDefault(_FindAuctions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FindAuctions = function (_React$Component) {
    (0, _inherits3.default)(FindAuctions, _React$Component);

    function FindAuctions() {
        (0, _classCallCheck3.default)(this, FindAuctions);
        return (0, _possibleConstructorReturn3.default)(this, (FindAuctions.__proto__ || (0, _getPrototypeOf2.default)(FindAuctions)).apply(this, arguments));
    }

    (0, _createClass3.default)(FindAuctions, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var parent = this.props.parent;


            var links = [(0, _jsx3.default)(_link2.default, {
                className: _FindAuctions2.default.link,
                route: true,
                to: (0, _urls.getAllUpcomingAuctionsUrl)()
            }, 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'auction_calendar'
            }), (0, _jsx3.default)(_reactFontawesome.FontAwesomeIcon, {
                icon: ['far', 'calendar-alt'],
                className: _FindAuctions2.default.calendar
            })), (0, _jsx3.default)(_link2.default, {
                className: _FindAuctions2.default.link,
                route: true,
                to: '/find-auctions-near-me'
            }, 1, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'auctions_near_me'
            })), (0, _jsx3.default)(_link2.default, {
                className: _FindAuctions2.default.link,
                route: true,
                to: (0, _urls.getAuctioneerDirectoryUrl)()
            }, 2, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'auction_house_directory'
            })), (0, _jsx3.default)(_link2.default, {
                className: _FindAuctions2.default.link,
                route: true,
                to: (0, _urls.getAuctionResultsUrl)()
            }, 3, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'past_auction_results'
            }))];

            var title = (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'find_auctions'
            });

            return (0, _jsx3.default)(_dropDownMenu2.default, {
                links: links,
                parent: parent,
                placement: 'bottom',
                title: title,
                titleClass: _FindAuctions2.default['auction-title'],
                dropdownClass: _FindAuctions2.default.aDropDown
            });
        }
    }]);
    return FindAuctions;
}(React.Component);

exports.default = FindAuctions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Navigation/FindAuctions.js
// module id = FtE5
// module chunks = 60